import React, {useEffect, useState} from 'react';
import type {Project} from 'rendition-core';

import {useUserContext, AuthState} from 'Contexts/UserContext/UserContext';
import {getProject} from 'Common/api';
import {Loading} from 'Components/Loading';
import {StyleGuide} from './StyleGuide';

export const Styleguide = () => {
    const [loading, setLoading] = useState(false);
    const [project, setProject] = useState<Project>();
    const {status, userId} = useUserContext();

    useEffect(() => {
        const getProj = async () => {
            const proj = await getProject(userId);
            setProject(proj);
            setLoading(false);
        };
        if (status === AuthState.SIGNED_IN_PAID) {
            getProj();
        }
    }, [status, userId]);

    const isLoading = loading || !project;

    return (
        <div className="flex h-full w-full flex-col items-start">
            {isLoading ? (
                <div className="flex w-full flex-grow items-center justify-center">
                    <Loading />
                </div>
            ) : (
                <StyleGuide project={project!} setProject={setProject} />
            )}
        </div>
    );
};
